var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('NlTabs',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.openOnce[props.tab.index])?_c('UrlTable',{attrs:{"type":"all","status":props.tab.type,"scrap-pending":false,"price-update-pending":false,"display-serp-buttons":false}}):_vm._e()]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }